// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3FHV7","label":"SetPasswdForm_label__1T7GS"};